var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-meta',{attrs:{"count":_vm.browsers.length,"label":"Browsers","intro":"All browsers affected by this card."}},_vm._l((_vm.browsers),function(b){return _c('item-browser',{key:b.id,attrs:{"browser":b}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }